import Animate from "./partials/animate";
import Form from "./partials/form";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($element => (new Animate($element)));
    $wrapper.querySelectorAll('[data-form]').forEach($element => (new Form($element)));
}

(function() {
    window.initDom(document);
})();